/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Stage_In_TransitInputs */

const tr_geliver_tracking_stage_in_transit = /** @type {(inputs: Geliver_Tracking_Stage_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yolda`)
};

const en_geliver_tracking_stage_in_transit = /** @type {(inputs: Geliver_Tracking_Stage_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Transit`)
};

const de_geliver_tracking_stage_in_transit = /** @type {(inputs: Geliver_Tracking_Stage_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterwegs`)
};

const ru_geliver_tracking_stage_in_transit = /** @type {(inputs: Geliver_Tracking_Stage_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В пути`)
};

/**
* | output |
* | --- |
* | "In Transit" |
*
* @param {Geliver_Tracking_Stage_In_TransitInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_stage_in_transit = /** @type {((inputs?: Geliver_Tracking_Stage_In_TransitInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Stage_In_TransitInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_stage_in_transit(inputs)
	if (locale === "de") return de_geliver_tracking_stage_in_transit(inputs)
	if (locale === "ru") return ru_geliver_tracking_stage_in_transit(inputs)
	return tr_geliver_tracking_stage_in_transit(inputs)
});